var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ajax-load',{attrs:{"url":_vm.$apiUrl.getForumEventUrl(_vm.$route.params),"transform":response => response.data.data.items[0]},on:{"input":function($event){return _vm.$store.commit('UPDATE_BREAD_CRUMBS', {event: $event})}},model:{value:(_vm.event),callback:function ($$v) {_vm.event=$$v},expression:"event"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }